<template>
  <div class="box-voice">
    <div class="voice-header m-b-10">
      <div>
        <v-icon>fa fa-reply</v-icon>
        <span class="m-l-5">Quick Reply</span>
      </div>
      <div>
        <v-icon small class="m-l-5" @click="deletePrompt">
          fa-times-circle
        </v-icon>
      </div>
    </div>

    <div class="container">
      <div>
        <v-text-field
          v-model="prompt.payload.message"
          label="Title"
          placeholder="Enter title"
          hide-details
          class="m-t-5"
        ></v-text-field>
      </div>
      <div>
        <div v-for="(button, index) in prompt.payload.buttons" :key="index">
          <div class="box-button">
            <div class="box-button-left">
              <div class="box-button-left-inside">
                <div class="label-button-type">Button</div>
                <v-text-field
                  id="button-text-title"
                  label="Title"
                  placeholder="Title"
                  v-model="button.title"
                  class="button-text-field"
                  dense
                  hide-details
                >
                </v-text-field>
                <v-text-field
                  id="button-text-title"
                  label="Message"
                  placeholder="Message"
                  v-model="button.payload"
                  class="button-text-field"
                  dense
                  hide-details
                >
                </v-text-field>
              </div>
            </div>
            <div
              v-if="prompt.payload.buttons.length > minButton"
              class="box-button-delete"
            >
              <v-icon small @click="deleteButton(index)">
                fa-times-circle
              </v-icon>
            </div>
          </div>
        </div>
        <div
          v-if="prompt.payload.buttons.length < maxButton"
          class="box-button-add"
          @click="addButton()"
        >
          <v-icon class="outline m-l-5">fa-plus-square</v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'PayloadQuickReply',
  props: {
    index: Number,
    prompt: Object,
    minioHost: String,
    items: Array
  },
  data() {
    return {
      payload: {},
      minButton: 1,
      maxButton: 10
    }
  },
  watch: {
    prompt: {
      deep: true,
      immediate: true,
      handler(val) {
        // console.log('handler', this.prompt.payload)
      }
    }
  },
  methods: {
    deletePrompt() {
      this.$emit('deletePrompt', this.index)
    },

    getButtonInitialData() {
      return {
        type: 'text',
        title: '',
        payload: ''
      }
    },

    addButton() {
      const data = this.getButtonInitialData()
      this.prompt.payload.buttons.push(data)
    },

    deleteButton(index) {
      this.prompt.payload.buttons.splice(index, 1)
    }
  }
}
</script>

<style scoped lang="scss">
.font-size-body {
  max-width: 300px;
  display: flex;
  text-align: justify;
  text-justify: inter-word;
  padding-left: 4px;
  margin-left: 4px;
  padding-right: 4px;
  margin-right: 4px;
  margin-bottom: 0px;
  word-wrap: break-word;
}

.width20px {
  min-width: 20px;
}

.top-5 {
  margin-top: 5px;
  padding: 5px 10px 10px 10px;
  background: white;
}

.dropdown-title {
  font-size: 14px;
}

.dropdown-text {
  font-size: 11px;
  color: $text-color;
}

.margin8px {
  margin: 8px 0;
}

.box-voice {
  background-color: #f7f7f7;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ebebeb;
}

.voice-header {
  display: flex;
  justify-content: space-between;
}

.box-delete {
  display: flex;
  justify-content: right;
}

.container {
  // margin: 5px;
  padding: 10px;
  background-color: #fff;
  border: 1px solid #ebebeb;
  border-radius: 5px;
}

.box-text {
  margin: 10px 0 5px 0;
}

.box-button {
  margin: 5px 0px;
  display: flex;
  border-radius: 2px;
  border: 1px solid #ebebeb;
}

.box-button-left {
  padding: 10px 0px;
  width: 95%;
  display: flex;
  // justify-content: center;
}

.box-button-left-inside {
  width: 100%;
  padding-left: 10px;
}

.label-button-type {
  font-size: 11px;
}

.input-button-title {
  color: #8196b8;
  width: 80%;
  text-align: center;
}

.button-text-field {
  width: 100%;
  margin-top: 20px;
}

.box-button-add {
  margin: 5px 0px;
  padding: 10px 0px;
  border-radius: 2px;
  border: 1px dashed #ebebeb;
  display: flex;
  justify-content: center;
}

.box-button-delete {
  width: 5%;
  margin-left: 5px;
  display: flex;
  justify-content: center;
}
</style>
